module.exports = __webpack_public_path__ + "img/article-daily-share-btn.e873c211.png";